module.exports = __webpack_public_path__ + "img/gb.05a4a902.svg";